// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  TUpdateProjectRequest,
  TUpdateProjectModel,
  IMappers,
  TUpdateProjectResponse,
  TUpdateProjectResponse_1,
  TUpdateProjectResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TUpdateProjectModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'promotions-flow-control',
  pathApi: '/v1/update-project/',
  requestType: 'json',
  interserviceAuthEnabled: true,
} as TUpdateProjectModel;

export function createUpdateProjectModel(parameters: TUpdateProjectRequest): TUpdateProjectModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IUpdateProjectOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TUpdateProjectRequest;
}

export async function fetchUpdateProject<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IUpdateProjectOptions<TResponse200, TResponse400>): Promise<TUpdateProjectResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createUpdateProjectModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TUpdateProjectResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TUpdateProjectResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TUpdateProjectResponse;
}
